import type { CustomCellRendererProps } from "ag-grid-react";
import { clsx } from "clsx";
import { getCssColor } from "widgets/utils";

import style from "../styles/Cell.module.css";
import { extractValueAsArray } from "../utils/tables.ts";
import { ColoredLabelCell } from "./ColoredLabelCell.tsx";
import { TruncateColoredLabelList } from "./TruncateColoredLabelList.tsx";

export const ColoredLabelListCell = (props: CustomCellRendererProps) => {
  const values = extractValueAsArray(props.value);

  if (values.length === 1) {
    return <ColoredLabelCell {...props} value={values[0]} />;
  }

  const items = values.map((value, index) => {
    const { color, label, value: rawValue } = (value ?? {}) as { color?: unknown; label?: unknown; value?: unknown };
    const labelText = String(rawValue ?? label ?? "");
    return {
      key: `${labelText}-${index}`,
      label: labelText,
      color: getCssColor(typeof color === "string" ? color : undefined),
    };
  });

  const fullText = items.map((item) => item.label).join(", ");

  return (
    <div className={clsx(style.cell, style.truncate_container)}>
      <span className={style.truncate_autosize} aria-hidden>{fullText}</span>
      <TruncateColoredLabelList items={items} className={style.truncate_content} />
    </div>
  );
};
